import { render, staticRenderFns } from "./UpcomingArrivalsTable.vue?vue&type=template&id=61af3e72&scoped=true&"
import script from "./UpcomingArrivalsTable.vue?vue&type=script&lang=js&"
export * from "./UpcomingArrivalsTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/table.css?vue&type=style&index=0&id=61af3e72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af3e72",
  null
  
)

export default component.exports